/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
var config = {};

if (process.env.VUE_APP_ENV === 'dev') {
  Object.assign(config, {
    API: 'https://newdev-api.hellobike.com/api',
    switchApi: 'https://dev-switchpowerapi.hellobike.com/api',
    UBT_API: 'https://dev-ubt.hellobike.com/yukon_logging',
    // UBT_API: '/devUbtApi',
    wxAppId: 'wxb2315cf308c9a24d',
    aliAppId: '2018091261337379'
  }); // Object.assign(config, {
  //   API: 'https://fat-api.hellobike.com/api',
  //   switchApi: 'https://fat-switchpowerapi.hellobike.com/api',
  //   UBT_API: 'https://fat-ubt.hellobike.com/yukon_logging',
  //   wxAppId: 'wxb2315cf308c9a24d',
  // });
} else if (process.env.VUE_APP_ENV === 'fat') {
  Object.assign(config, {
    API: 'https://fat-api.hellobike.com/api',
    switchApi: 'https://fat-switchpowerapi.hellobike.com/api',
    UBT_API: 'https://fat-ubt.hellobike.com/yukon_logging',
    wxAppId: 'wxb2315cf308c9a24d',
    aliAppId: '2018091261337379'
  });
} else if (process.env.VUE_APP_ENV === 'uat') {
  Object.assign(config, {
    API: 'https://uat-api.hellobike.com/api',
    switchApi: 'https://uat-switchpowerapi.hellobike.com/api',
    UBT_API: 'https://uat-ubt.hellobike.com/yukon_logging',
    wxAppId: 'wxb2315cf308c9a24d',
    aliAppId: '2018091261337379'
  });
} else if (process.env.VUE_APP_ENV === 'pro') {
  Object.assign(config, {
    API: 'https://api.hellobike.com/api',
    switchApi: 'https://switchpowerapi.hellobike.com/api',
    UBT_API: 'https://ubt.hellobike.com/yukon_logging',
    wxAppId: 'wxb2315cf308c9a24d',
    aliAppId: '2018091261337379'
  });
}

export default config;